import {Component, Input, OnInit, HostListener} from '@angular/core';
import {Location} from '@angular/common';

@Component({
    selector: 'page-panel',
    templateUrl: './page-panel.component.html',
    styleUrls: ['./page-panel.component.scss']
})
export class PagePanel implements OnInit {
    screenHeight: String;
    screenMargin = 250;

    @Input() title = 'This is title';
    @Input() footer = 'Więcej';
    @Input() footerColor = 'transparent';
    @Input() link: string;

    @Input()
    set floatingBtns(flag: boolean) {
        if (flag) {
            this.screenMargin = 250;
        }
    }

    @Input() rightText = '';

    //@HostListener('window:resize', ['$event'])
    onResize(event?) {
        this.screenHeight = (window.innerHeight - this.screenMargin) + 'px';
    }

    ngOnInit() {
        //this.onResize();
    }

    _footerPos = 'start';

    @Input('footerPos')
    set in(val) {
        this._footerPos = 'flex-' + val;
    }

    constructor(private _location: Location) {
    }

    sendBack() {
        this._location.back();
    }
}
